import { useEffect, useState } from "react";
import styles from "./CopyEventModal.module.css";
import Button from "../components/Button";
import { validateForm } from "../helpers/helperFunctions";
import { flashAlert } from "../global_js";
import { Navigate, useNavigate } from "react-router-dom";

function CopyEventModal({ eventdata, handleCopyEvent }) {
  //const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [banName, setBanName] = useState(eventdata.BanquetName);
  const [banDate, setBanDate] = useState(String(eventdata.BanDate).substring(0, 10));

  const user = JSON.parse(localStorage.getItem("userLogin")).user;

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
  };

  const makeInvalid = (e) => {
    e.target.classList.add("invalid");
  };

  return (
    <>
      <Button type="secondary" onClick={openModal}>
        Copy Event
      </Button>
      {isOpen && (
        <div className="modal-backdrop modal-backdrop-dark">
          <div className={`modal-content modal-narrow ${styles.modalTop}`}>
            <h3 className="modal-header">Copy Event</h3>
            <div>
              <form action="" onSubmit={handleCopyEvent} className={styles.copyEventForm} noValidate>
                <div className={styles.formSection}>
                  <label htmlFor="">Copied Banquet Name:</label>
                  <input
                    type="text"
                    id="addBanquetName"
                    name="banName"
                    value={banName}
                    onChange={(e) => setBanName(e.target.value)}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Banquet name required</div>
                </div>
                <div className={styles.formSection}>
                  <label htmlFor="">New Banquet Date:</label>
                  <input type="date" id="newBanquetDate" name="banDate" value={banDate} onChange={(e) => setBanDate(e.target.value)} />
                  <div className="invalid-feedback">Banquet name required</div>
                </div>
                <div className={styles.formSelectButtons}>
                  <Button type="primary">Copy</Button>
                  <Button type="save" onClick={closeModal}>
                    Close
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CopyEventModal;
